import { tableFromIPC } from "@uwdata/flechette";
import { sortBy } from "lodash";
import { useState, useEffect } from "react";
import {
  parseArrowToTimeSeries,
  generateCommonTimeline,
  extrapolateToTimeseries,
} from "../Components/dataUtils";
import { TimeSeries } from "../Charts/TimeSeriesChart";

export const useMapResponseToTimeseries = (data: Response) => {
  const [timeseries, setTimeSeries] = useState<TimeSeries[]>();

  useEffect(() => {
    async function fetchData() {
      if (!data) {
        return;
      }
      const arrayBuffer = await (data as Response).arrayBuffer();
      const table = tableFromIPC(arrayBuffer, { useProxy: true }).toArray();
      const parsedData = parseArrowToTimeSeries(table);

      const commonTimestamps = generateCommonTimeline(parsedData);
      const alignedSeries = parsedData.map((series) =>
        extrapolateToTimeseries(series, commonTimestamps),
      );

      setTimeSeries(sortBy(alignedSeries, "name"));
    }
    fetchData();
  }, [data]);

  return timeseries;
};
